import { createSelector } from '@reduxjs/toolkit'
import { differenceInHours, parseISO } from 'date-fns'

import type { ReduxState } from 'src/store/types'

import { getActiveCurrencyIdSelector } from '../currencies/selectors'

const getJackpotsRoot = (state: ReduxState) => state?.jackpots

export const getJackpotOptInSelector = createSelector(getJackpotsRoot, (jackpots) => jackpots?.optIn)
export const getJackpotGcContributeAmountSelector = createSelector(getJackpotsRoot, (jackpots) =>
  Math.trunc(Number(jackpots?.gcContributeAmount ?? 0)),
)
export const getJackpotPersonalTotalSelector = createSelector(getJackpotsRoot, (jackpots) =>
  Math.trunc(Number(jackpots?.personalTotal ?? 0)),
)
export const getJackpotThisWeekTotalSelector = createSelector(getJackpotsRoot, (jackpots) =>
  Math.trunc(Number(jackpots?.thisWeekTotal ?? 0)),
)
export const getJackpotNextWeekTotalSelector = createSelector(getJackpotsRoot, (jackpots) =>
  Math.trunc(Number(jackpots?.nextWeekTotal ?? 0)),
)

export const getJackpotPersonalExpireSelector = createSelector(getJackpotsRoot, (jackpots) => {
  return jackpots?.endAt
})

export const showJackpotPersonalExpireBadgeSelector = createSelector(getJackpotsRoot, (jackpots) => {
  const { createdAt, endAt, period } = jackpots

  return differenceInHours(parseISO(endAt), parseISO(createdAt)) < period * 24
})

export const getJackpotThisWeekExpireSelector = createSelector(getJackpotsRoot, (jackpots) => jackpots?.thisWeekExpire)
export const getJackpotNextWeekExpireSelector = createSelector(getJackpotsRoot, (jackpots) => jackpots?.nextWeekExpire)

export const getJackpotMyStashWinSelector = createSelector(getJackpotsRoot, (jackpots) => jackpots?.myStashWin)

export const enableJackpotSelector = createSelector(
  (_: ReduxState, gameType?: string) => gameType,
  (gameType) => {
    return gameType !== 'bingo'
  },
)

export const enableJackpotListenerSelector = createSelector(
  getJackpotOptInSelector,
  getActiveCurrencyIdSelector,
  (optIn, activeCurrency) => {
    return optIn && activeCurrency === 'GC'
  },
)

export const isWaitingAcceptPersonalJackpotRequestSelector = createSelector(
  getJackpotsRoot,
  (jackpots) => jackpots.waitingAcceptPersonalJackpotRequest,
)
